import {useState, useEffect} from 'react';

export default ({apiServer}) => {
  const [referralData, setReferralData] = useState({
    subjects: [],
    locations: [],
    studyTypes: [],
    studyYears: []
  });

  useEffect(() => {

    const fetchData = async (url, type, mapper) => {
      try {
        const response = await fetch(url);
        const body = await response.json();
        referralData[type] = body.results.map(mapper);
        setReferralData(referralData);
      } catch (error) {
        console.error(error);
      }
    };

    const mapper = ({value, label}) => ({label: label, value: value});
    fetchData(apiServer + "/api/siuk/subjects", 'subjects', mapper);
    fetchData(apiServer + "/api/siuk/locations", 'locations', ({name, iso, dialling_code}) => ({name: name, iso: iso, dialling_code: dialling_code}));
    fetchData(apiServer + "/api/siuk/study_types", 'studyTypes', mapper);
    fetchData(apiServer + "/api/siuk/study_years", 'studyYears', mapper);

  }, [referralData, apiServer]);

  return referralData;
}
